// extracted by mini-css-extract-plugin
export var externalLink = "_9q-0";
export var internalLinkLabel = "_9q-1";